<template>
  <div class="">
    <!-- 诉讼地位：h pie-->
    <div class="row">
      <div class="col">
        <chart-box title="诉讼地位">
          <div
            v-loading="isLoading"
            class="chart-wrapper"
            style="height:320px;"
          >
            <pie-chart
              v-if="companyRiskChartData.h && companyRiskChartData.h.length"
              :options="translatePieData('h', companyRiskChartData.h, '300px')"
            />
            <chart-empty
              v-if="!isLoading && (!companyRiskChartData.h || !companyRiskChartData.h.length)"
              :empty-height="height"
            />
          </div>
          <div class="chart-info">
            <p>
              本部分统计了当前条件下，该机构在所涉案件中的诉讼地位。
            </p>
            <p>
              攻方是指作为原告、上诉人、再审申请人、执行申请人的当事人，守方是作为被告、被上诉人、再审被申请人、执行被申请人的当事人。
            </p>
          </div>
        </chart-box>
      </div>
      <div class="col">
        <chart-box title="程序分布">
          <div
            v-loading="isLoading"
            class="chart-wrapper"
            style="height:320px;"
          >
            <pie-chart
              v-if="companyRiskChartData.g && companyRiskChartData.g.length"
              :options="translatePieData('g', companyRiskChartData.g, '300px')"
            />
            <chart-empty
              v-if="!isLoading && (!companyRiskChartData.g || !companyRiskChartData.g.length)"
              :empty-height="height"
            />
          </div>
          <div class="chart-info">
            <p>
              本部分统计了当前条件下，该机构所涉案件的程序分布情况。
            </p>
          </div>
        </chart-box>
      </div>
    </div>
    <div
      v-loading="isLoading"
      class="row"
    >
      <div class="col">
        <chart-box title="案件类型">
          <div
            v-loading="isLoading"
            class="chart-wrapper"
            style="height:340px;"
          >
            <!-- 案件类型：j pie-->
            <pie-chart
              v-if="companyRiskChartData.j && companyRiskChartData.j.length"
              :options="translatePieData('j', companyRiskChartData.j, '300px')"
            />
            <chart-empty
              v-if="!isLoading && (!companyRiskChartData.j || !companyRiskChartData.j.length)"
              :empty-height="height"
            />
          </div>
          <div class="chart-info">
            <p>
              本部分统计了当前条件下，该机构所涉不同类型及各级案由案件的分布情况，支持点击案由进行统计筛选。
            </p>
          </div>
        </chart-box>
      </div>
      <div class="col">
        <chart-box title="一级案由">
          <div
            v-loading="isLoading"
            class="chart-wrapper"
            style="height:180px;"
          >
            <!-- 一级案由：k line-->
            <bar-chart
              v-if="companyRiskChartData.k && companyRiskChartData.k.length"
              :options="translateBarData(companyRiskChartData.k, '#e57373')"
            />
            <div
              v-if="companyRiskChartData.k.length > 3"
              class="showMore"
              @click="showMore('k')"
            >
              查看更多
            </div>
            <div
              v-if="companyRiskChartData.k.length < 4"
              class="showMoreBox"
            />
            <chart-empty
              v-if="!isLoading && (!companyRiskChartData.k || !companyRiskChartData.k.length)"
              :empty-height="minHeight"
            />
          </div>
        </chart-box>
        <chart-box title="三级案由">
          <div
            v-loading="isLoading"
            class="chart-wrapper"
            style="height:180px;"
          >
            <!-- 三级案由：m line-->
            <bar-chart
              v-if="companyRiskChartData.m && companyRiskChartData.m.length"
              :options="translateBarData(companyRiskChartData.m, '#e57373')"
            />
            <div
              v-if="companyRiskChartData.m.length > 3"
              class="showMore"
              @click="showMore('m')"
            >
              查看更多
            </div>
            <div
              v-if="companyRiskChartData.m.length < 4"
              class="showMoreBox"
            />
            <chart-empty
              v-if="!isLoading && (!companyRiskChartData.m || !companyRiskChartData.m.length)"
              :empty-height="minHeight"
            />
          </div>
        </chart-box>
      </div>
      <div class="col">
        <chart-box title="二级案由">
          <div
            v-loading="isLoading"
            class="chart-wrapper"
            style="height:180px;"
          >
            <!-- 二级案由：l line-->
            <bar-chart
              v-if="companyRiskChartData.l && companyRiskChartData.l.length"
              :options="translateBarData(companyRiskChartData.l, '#e57373')"
            />
            <div
              v-if="companyRiskChartData.l.length > 3"
              class="showMore"
              @click="showMore('l')"
            >
              查看更多
            </div>
            <div
              v-if="companyRiskChartData.l.length < 4"
              class="showMoreBox"
            />
            <chart-empty
              v-if="!isLoading && (!companyRiskChartData.l || !companyRiskChartData.l.length)"
              :empty-height="minHeight"
            />
          </div>
        </chart-box>
        <chart-box
          v-loading="isLoading"
          title="四级案由"
          style="height:180px;"
        >
          <div class="chart-wrapper">
            <!-- 四级案由：o line-->
            <bar-chart
              v-if="companyRiskChartData.o && companyRiskChartData.o.length"
              :options="translateBarData(companyRiskChartData.o, '#e57373')"
            />
            <div
              v-if="companyRiskChartData.o.length > 3"
              class="showMore"
              @click="showMore('o')"
            >
              查看更多
            </div>
            <div
              v-if="companyRiskChartData.o.length < 4"
              class="showMoreBox"
            />
            <chart-empty
              v-if="!isLoading && (!companyRiskChartData.o || !companyRiskChartData.o.length)"
              :empty-height="minHeight"
            />
          </div>
        </chart-box>
      </div>
    </div>
    <el-dialog
      title="更多案由"
      :visible="dialogTableVisible"
      :show-close="true"
      width="500px"
      @close="close"
    >
      <div
        v-loading="isMoreLoading"
        class="list-wrapper"
      >
        <ul>
          <li
            v-for="item in moreList"
            :key="item.id"
          >
            <p>{{ item.description }} ({{ item.value }})</p>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BarChart from '@/components/echarts/bar'
import PieChart from '@/components/echarts/pie'
import ChartEmpty from '@/components/echarts/ChartEmpty'
import ChartBox from '@/components/echarts/ChartBox'
import radarService from '@/service/radar'

export default {
  name: 'CompanyRiskChart',
  components: {
    PieChart,
    BarChart,
    ChartBox,
    ChartEmpty
  },
  data () {
    return {
      companyRiskChartData: {
        h: [],
        g: [],
        k: [],
        l: [],
        m: [],
        o: []
      },
      isLoading: false,
      dialogTableVisible: false,
      moreList: [],
      companyName: '',
      height: '300px',
      minHeight: '160px',
      isMoreLoading: false
    }
  },
  created () {
    this.getCompanyName()
    this.getChartDetail()
  },
  methods: {
    close () {
      this.dialogTableVisible = false
    },
    getCompanyName () {
      var name = ''
      var value = ''
      var str = location.href
      var num = str.indexOf('?')
      str = str.substr(num + 1)
      var arr = str.split('&')
      for (var i = 0; i < arr.length; i++) {
        num = arr[i].indexOf('=')
        if (num > 0) {
          name = arr[i].substring(0, num)
          value = arr[i].substr(num + 1)
          this[name] = value
        }
      }
      this.companyName = decodeURIComponent(value)
    },
    showMore (item) {
      this.moreList = []
      this.dialogTableVisible = true
      this.isMoreLoading = true
      let field = item
      let params = {
        query: '机构名称:' + this.companyName,
        field: field
      }
      radarService.getRadarChartMore(params).then(res => {
        if (res.isSuccess) {
          this.moreList = res.data
          this.isMoreLoading = false
        } else {
          this.isMoreLoading = false
          this.$message.error(res.res.resultMsg)
          this.dialogTableVisible = false
        }
      })
    },
    getChartDetail () {
      this.isLoading = true
      let params = {
        query: '机构名称:' + this.companyName,
        fields: 'h,g,j,k,l,m,o'
      }
      radarService.getRadarChart(params).then(res => {
        if (res.isSuccess) {
          this.companyRiskChartData = res.data
          this.isLoading = false
        } else {
          this.isLoading = false
          this.$message.error(res.resultMsg)
        }
      })
    },
    translatePieData (type, data, height) {
      if (type === 'j') {
        return {
          data,
          config: {
            width: '100%',
            height: height,
            color: '#e57373',
            data: data.slice(0, 5),
            itemGap: 10,
            seriesCenter: ['50%', '40%'],
            legendIsJ: 'J',
            legendLeft: '20%',
            legendTop: '70%',
            legendTextStyle: {
              rich: {
                a: {
                  fontSize: 12,
                  color: '#4a4a4a',
                  fontWeight: 500,
                  padding: [0, 0, 0, 0]
                },
                b: {
                  fontSize: 12,
                  color: '#737373',
                  padding: [0, 5, 0, 0]
                },
                c: {
                  fontSize: 12,
                  color: '#a9a9a9',
                  padding: [0, 0, 0, 0]
                }
              }
            }
          }
        }
      } else {
        return {
          data,
          config: {
            width: '100%',
            height: height,
            color: '#e57373',
            data: data.slice(0, 5),
            itemGap: 10
          }
        }
      }
    },
    translateBarData (data, color) {
      return {
        data: data.slice(0, 3),
        config: {
          width: '100%',
          height: '160px',
          color: color
        }
      }
    }
  }
}
</script>

<style lang="stylus">
.row
  display: flex
  flex-direction: row
  border-bottom: 1px solid #eaeaea
  .col
    box-sizing: border-box;
    flex 1
    display: flex
    flex-direction: column
    padding 10px
  .chart-wrapper
    display: flex
    flex 1
    flex-direction: column
    .showMore
      height: 18px
      font-size: 12px
      cursor: pointer
      color: #a9a9a9
      margin-left: 20px
    .showMoreBox
      height: 18px
  .chart-info
    font-size: 12px
    font-weight: 500
    color: #a9a9a9
    box-sizing: border-box
    padding 0 10px
.list-wrapper
  height: 300px
  overflow-y auto
  p
    height: 30px
    line-height: 30px
    color: $color-txt
</style>
